<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chtitle" id="Acknowledgments"><span epub:type="pagebreak" id="pagexvii" title="xvii"><span class="bold">Acknowledgments</span></span></h2>
<p class="indentn">Immense thanks to Colonel (Ret) Jerry J. Burcham, my dear friend, who is profoundly important in the final shaping of this book through years of discussion of experiences and ideas and who at places within the book contributed anecdotes of his similar combat experiences and conclusions about the war, and who in the final stages of publication edited the proofs during an extended period in which I was unable to do so.</p>
<p class="indent">Lieutenant General (Ret) Dave R Palmer for his contribution of the Foreword.</p>
<p class="indent">Merle L. Pribbenow, Jr., retired CIA officer with vast experience in Indochina matters, for translations from Vietnamese histories and documents, and for sharing his insights to the nature of South and North Vietnamese and their conduct of the war.</p>
<p class="indent">General of the Army Jean Delaunay, former French Army Chief of Staff who as a lieutenant fought the Viet Minh, who put me in contact with other French generals and Vietnam combatants, and who for decades has sent me material and provided invaluable insights to the French conduct of the war.</p>
<p class="indent">Lieutenant Colonel (Marine Corps, RVN) Nguyen Minh Chau. If all district chiefs had been as capable, honest, and dedicated to the people as my deceased friend Chau, America might never have fought a Vietnam War.</p>
<p class="indent">Anne Le Dimna Marsilio, formerly of the French Air Force, who ensured the accuracy of my translations from the French.</p>
<p class="indent">Research team of 1–4 Cavalry, especially Ronald M. Halicki for getting research started, Colonel (Ret) Carl H. “Skip” Bell III, for heading the team; archivists (former) Sergeant Michael T. O’Connor, and Sergeant First Class (Ret) Terry L. Valentine, for their years of efforts and insights; Major (Ret) James C. Pitts, for his significant input; Lieutenant Colonel (Ret) James A. “Jay” Ward, for map research and production; Major (Ret) Thomas C. Witter, for insights to the nature of civil affairs and pacification efforts.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Acknowledgments.vue?4a212d47